module.exports = __webpack_public_path__ + "static/media/Future.d046731d.jpg";